const baseCheckbox = {
  appearance: 'none',
  cursor: 'pointer',
  borderWidth: '1px',
  borderColor: 'neutrals.3',
  borderStyle: 'solid',
  borderRadius: '4px',
  backgroundColor: 'neutrals.0',
  transition: 'background-color 0.25s 0.0833333333s',
  transitionDelay: '.1s',
  mr: 4,
  ':not(&:checked)&:hover': {
    borderWidth: '2px',
    borderColor: 'secondary.1'
  },
  '&:checked': {
    borderColor: 'secondary.1',
    backgroundColor: 'secondary.1',
    '&:after': {
      display: 'block'
    },
    '&:hover': {
      borderColor: 'secondary.2',
      backgroundColor: 'secondary.2'
    }
  }
}

const baseAfterContent = {
  content: 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS40Mzk5IDAuNzI1ODhDMTUuNzc1NCAwLjk2ODgyIDE1Ljg1MDQgMS40Mzc3MyAxNS42MDc1IDEuNzczMjJMNS40ODM0MyAxNS43NTRMMC41MjIzMTcgMTEuNjU1MUMwLjIwMjk5NCAxMS4zOTEzIDAuMTU4MDA2IDEwLjkxODUgMC40MjE4MzQgMTAuNTk5MkMwLjY4NTY2MyAxMC4yNzk5IDEuMTU4NCAxMC4yMzQ5IDEuNDc3NzIgMTAuNDk4N0w1LjIwNjI2IDEzLjU3OTNMMTQuMzkyNiAwLjg5MzQ1NEMxNC42MzU1IDAuNTU3OTY1IDE1LjEwNDQgMC40ODI5NCAxNS40Mzk5IDAuNzI1ODhaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K")',
  display: 'none',
  height: '16px',
  width: '16px',
  transition: 'display 0.25s 0.0833333333s',
  transitionDelay: '.1s'
}

const checkboxes = {
  standard: {
    ...baseCheckbox,
    '&:after': {
      ...baseAfterContent,
      padding: '7px'
    },
    width: '32px',
    height: '32px'
  },
  small: {
    ...baseCheckbox,
    '&:after': {
      ...baseAfterContent,
      padding: '3px'
    },
    width: '24px',
    height: '24px'
  }
}

export default checkboxes
